<template>
  <div>
    <div>
      <label>{{ $t("Врач ID") }}</label>
      <div style="display: flex; height: 37px; justify-content: space-between;">
        <div style="width: calc(100% - 50px);">
          <!-- @input="direct" -->
          <v-select
            :filter="fuseSearch"
            id="naprovitel"
            :options="Naprovitel"
            :get-option-label="option => option.name"
            :reduce="option => option.id"
            v-model="direct_id"
          >
            <template #option="{ name, direct_id }">
              {{ name }}
              <br />
              <b>{{ direct_id }}</b>
            </template>
          </v-select>
        </div>
        <b-button
          class="navbarBtn-nap"
          variant="primary"
          v-b-modal="'nap-modal-nap' + indBolim"
          @click="getMed"
        >
          +
        </b-button>
        <b-modal
          :id="'nap-modal-nap' + indBolim"
          :title="$t('Напровитель')"
          hide-footer
        >
          <div>
            <div>
              <div>
                <span>
                  <span class="shirift">{{ $t("Ф.И.Ш") }}</span>
                  <span style="color: red;">*</span>
                  <span v-if="errorsNap !== null">
                    <span
                      style="color: red; font-size: 9px"
                      v-if="!errorsNap.name.required"
                      >{{ $t("Ф.И.Ш тўлдирилиши керак") }}</span
                    >
                    <span
                      style="color: red; font-size: 9px"
                      v-if="!errorsNap.name.minLength"
                      >{{ $t("Ф.И.Ш да камида 4 та белги бўлиши керак") }}</span
                    >
                  </span>
                </span>
                <b-input
                  id="naprovitel-name"
                  v-model="NapData.name"
                  type="text"
                />

                <span>
                  <span class="shirift">{{ $t("Вакил") }}</span>
                  <span style="color: red;">*</span>
                  <span v-if="errorsNap !== null">
                    <span
                      style="color: red; font-size: 9px"
                      v-if="!errorsNap.name.required"
                      >{{ $t("Ф.И.Ш тўлдирилиши керак") }}</span
                    >
                  </span>
                </span>
                <v-select
                  :options="MedPris"
                  label="name"
                  :reduce="option => option.id"
                  v-model="NapData.med_id"
                />
              </div>
              <div>
                <span>
                  <span class="shiri">
                    {{ $t("ID") }}
                  </span>
                  <span style="color: red;">*</span>
                  <span v-if="errorsNap !== null">
                    <span
                      style="color: red; font-size: 9px"
                      v-if="!errorsNap.direct_id.required"
                      >{{ $t("ID тўлдирилиши керак") }}</span
                    >
                  </span>
                </span>

                <b-input
                  id="naprovitel-name"
                  v-model="NapData.direct_id"
                  type="number"
                />
              </div>
              <div class="CreateName">
                <b-button
                  class="modalBtn1"
                  size="sm"
                  style="height: 37px;"
                  variant="danger "
                  @click="close"
                >
                  <b-icon icon="calendar2-x"></b-icon>
                  {{ $t("Бекор қилиш") }}
                </b-button>
                <b-button
                  class="mt-3 ml-2 modalBtn"
                  @click="Save"
                  variant="success"
                >
                  <b-icon icon="calendar2-plus"></b-icon>
                  {{ $t("Сақлаш") }}
                </b-button>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
    <div style="display: flex; flex-wrap: wrap;">
      <div
        class="item-child-t"
        v-for="(itemTek, indTek) in itemBol"
        :key="indTek"
        :style="localUser.role != 'Hamshira' ? 'width: 517px; margin-right: 10px;' : 'width: 340px; margin-right: 10px;'"
      >
        <div class="tek-item-t">
          <div v-if="localUser.role != 'Hamshira'">
            <div style="display: flex; cursor: pointer;">
              <div style="display: flex; width: 397px;">
                <b-form-checkbox
                  @change="ChakkedType(itemTek)"
                  v-model="itemTek.select"
                  :value="true"
                  :unchecked-value="false"
                >
                  {{ itemTek.name }}
                </b-form-checkbox>
              </div>
              <div 
                style="width: 100px; border: 1px solid #ccc; border-radius: 7px; margin-right: 10px;" 
                v-if="!itemTek.type && itemTek.ins_setting == 'reagent'" 
                v-for="itemCh in itemTek.inspectionchild"
              >
                <div v-for="item in itemCh.reagents">
                  {{ item.count | numFormat }}
                </div>
              </div>
              <input 
                v-if="itemTek.ins_setting == 'reagent'" 
                class="shif-price" style="width: 45px; margin-right: 3px;" 
                type="number"
                min="0"
                v-model="itemTek.count"
              >
              <div v-if="!itemTek.type" style="display: flex;">
                <span v-if="$store.state.bemor.citizen">{{
                  itemTek.citizen_price | numFormat
                }}</span>
                <span v-else>{{ itemTek.price | numFormat }}</span>
              </div>
            </div>
            <div class="item-child" v-if="itemTek.type">
              <TekChild
                :itemChild="itemTek.inspectionchild"
                :TekItem="itemTek"
                @ChakkedChild="ChakkChild"
              />
            </div>
          </div>
          <div v-else>
            <b-form-checkbox
              @change="ChakkedType(itemTek)"
              style="font-size: 20pt; background: rgb(23 162 184 / 24%); color: #000; font-weight: 400; border-radius: 10px; border: 1px solid rgb(23 162 184);"
              v-model="itemTek.select"
              :value="true"
              :unchecked-value="false"
            >
              {{ itemTek.name }}
            </b-form-checkbox>
            <div style="font-size: 13pt; font-weight: 500; text-align: center;">
              <div 
                style="width: 100px; border: 1px solid #ccc; border-radius: 7px; margin-right: 10px;" 
                v-if="!itemTek.type && itemTek.ins_setting == 'reagent'" 
                v-for="itemCh in itemTek.inspectionchild"
              >
                <div v-for="item in itemCh.reagents">
                  {{ item.count | numFormat }}
                </div>
              </div>  
            </div>
            <div style="font-size: 13pt; font-weight: 500; text-align: center;">{{ itemTek.price | numFormat }}</div>
            <div style="display: flex; justify-content: center; margin-top: 10px;">
              <b-button
                class="dori-push"
                variant="outline-success"
                @click="changeCount(itemTek, true)"
              >
                +
              </b-button>
              <input
                v-if="itemTek.ins_setting == 'reagent'"
                class="shif-price ml-2 mr-2"
                style="width: 45px; margin-right: 3px;"
                type="number"
                min="0"
                v-model="itemTek.count"
              >
              <b-button
                class="dori-push"
                variant="outline-warning"
                @click="changeCount(itemTek, false)"
              >
                -
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TekChild from "./TekChild.vue";
import { required, minLength } from "vuelidate/lib/validators";
import Fuse from "fuse.js";
export default {
  props: ["itemBol", "indBolim", "Naprovitel"],
  components: {
    TekChild
  },
  data() {
    return {
      itemsPerChunk: 1,
      localUser: JSON.parse(localStorage.getItem("user")),
      NapData: {
        direct_id: null,
        name: "",
        med_id: null,
        bonus_type: 1,
        bonus: 0
      },
      direct_id: null,
      Deselect: {
        render: createElement => createElement("span", "")
      },
      MedPris: [],
      bonus_type: [
        { id: 0, name: "Naqd" },
        { id: 1, name: "Foiz" }
      ],
      errorsNap: null
    };
  },
  validations: {
    NapData: {
      name: {
        required,
        minLength: minLength(4)
      },
      direct_id: {
        required
      },
      med_id: {
        required
      }
    }
  },
  computed: {
    // chunkedItems() {
    //   const chunks = [];
    //   for (let i = 0; i < this.itemBol.length; i += this.itemsPerChunk) {
    //     chunks.push(this.itemBol.slice(i, i + this.itemsPerChunk));
    //   }
    //   return chunks;
    // }
  },
  methods: {
    changeCount(item, type){
      this.$emit('changeCount', item, type, this.indBolim);
    },
    ChakkedType(item) {
      if(!Number(item.count)){
        this.$emit('changeCount', item, 1, this.indBolim);
      }
      if (this.$store.state.bemor.id) {
        this.$emit("itemTek", item, this.direct_id);
      } else {
        this.$emit("itemTek", item, this.direct_id);
        return (item.select = false);
      }
    },
    ChakkChild(TekItem, child) {
      this.$emit("chekkTekChild", TekItem, child, this.direct_id);
    },
    getMed() {
      let s = this;
      axios({
        method: "get",
        url: "/med_direct/all"
      }).then(res => {
        if (res) {
          s.MedPris = res.data.data;
        }
      });
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ["name", "direct_id"],
        shouldSort: true
      });
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list;
    },
    Save() {
      let self = this;
      this.$v.$touch();
      if (this.$v.NapData.$error == false) {
        axios({
          method: "post",
          url: "/direct/create",
          data: self.NapData
        }).then(data => {
          if (data) {
            self.$bvModal.hide("nap-modal" + self.indBolim);
            this.$emit("naprovitel", data.data.data);
            // self.getNaprovitel()
            self.direct_id = data.data.data.id;
            self.NapData = {
              direct_id: null,
              name: "",
              med_id: null,
              bonus: 0
            };
          }
        });
      } else {
        self.errorsNap = self.$v.NapData;
      }
    },
    close() {
      this.NapData = {
        direct_id: null,
        name: "",
        med_id: null,
        bonus: 0
      };
    }
  }
};
</script>
<style>
.dori-push{
  /* font-size: 14pt; */
  font-weight: 600;
  border: 2px solid;
}
/* .success{
  background: #1292018c;
}
.warning{
  background: #c579078c;
} */
.table-style {
  background: #fff;
}
.item-child-t {
  margin: 3px;
  display: flex;
  /* padding: 5px; */
  background: #f0f0f03d;
  border-radius: 5px;
  /* border: 1px solid #ccc; */
}
.Tekshiruvchi-index {
  width: 530px;
}
.item-child {
  border: 1px solid rgb(46, 165, 255);
  width: 100%;
  overflow: auto;
  background: #fff;
  border-radius: 10px;
  margin-top: 5px;
  max-height: 850px;
}
.border_top {
  border-top: 1px solid #ccc;
}
.tek-item-t {
  border: 1px solid rgb(46, 165, 255);
  width: 100%;
  background: #fff;
  padding: 5px;
  border-radius: 7px;
  overflow: auto;
  /* margin-top: 5px; */
  max-height: 1000px;
}
</style>
